import { administrationModule, attestBookModule, protocolsModule, reportModule, studentProfileModule } from "./shared";

export const schoolsData = [
  {
    iconComponent: 'so-icon',
    title: 'СПИСЪК-ОБРАЗЕЦ',
    details: [
      {
        text: 'Актуализиране и изпращане на данни от и към НЕИСПУО винаги, когато е необходимо'
      },
      {
        text: 'Въвеждане на данните за списък-образец № 1 в интуитивна електронна среда'
      },
      {
        text: 'Преглеждане на архив на списък-образците от предходни години, ако са били създадени с модула'
      },
    ]
  },
  {
    iconComponent: 'dnevnik-icon',
    title: 'ЕЛЕКТРОНЕН<br>ДНЕВНИК',
    details: [
      {
        text: 'Администриране на целия процес по водене на електронните дневници съгласно Наредба № 8 от 11.08.2016 г.'
      },
      {
        text: 'Двустранна интеграция с НЕИСПУО'
      },
      {
        text: 'Администриране на лекторските часове и генериране на книга за лекторските часове'
      },
      {
        text: 'Генериране на различни справки, свързани с отсъствията и резултатите на учениците, архив от минали години и генериране на PDF файл на дневниците'
      }
    ]
  },
  studentProfileModule,
  protocolsModule,
  reportModule,
  {
    iconComponent: 'diploma-icon',
    title: 'ДИПЛОМИ',
    details: [
      {
        text: 'Отпечатване в програмата АдминПро на дипломи, свидетелства и удостоверения, както и техните приложения и дубликати'
      },
      {
        text: 'Автоматично зареждане на необходимите данни за отпечатване на документите – за абонати на модул „Електронен дневник“ от платформата АдминПлюс'
      },
      {
        text: 'Прецизиране на текста за печат спрямо бланката на документа'
      },
      {
        text: 'Създаване на експортен файл за качване в НЕИСПУО'
      },
    ]
  },
  {
    iconComponent: 'asc-icon',
    title: 'СЕДМИЧНО<br>РАЗПИСАНИЕ',
    details: [
      {
        text: 'Софтуер за изготвяне на седмични учебни разписания с възможност за задаване на изискванията на Наредба № 10 от 19.06.2014 г. '
      },
      {
        text: 'Възможност за зареждане на данните от учебния план от НЕИСПУО към софтуера'
      },
      {
        text: 'Автоматичен генератор – само за няколко минути генераторът ще предложи вариант на седмично разписание, като се съобрази с въведените условия и ограничения'
      },
      {
        text: 'Прехвърляне на готовото седмично разписание в електронните дневници на АдминПлюс и на НЕИСПУО'
      },
    ]
  },
  {
    iconComponent: 'documents-icon',
    title: 'УЧИЛИЩНА <br>ДОКУМЕНТАЦИЯ',
    details: [
      {
        text: 'Примерни документи за администриране на различни процеси в училищата'
      },
      {
        text: 'Експорт на примерните документи в PDF и DOC формат'
      },
      {
        text: 'Разпечатване в неограничен брой копия на всеки документ'
      },
      {
        text: 'Нормативна уредба в системата на образованието'
      },
    ]
  },
{
    iconComponent: 'kd-icon',
    title: 'КНИГИ ЗА ДЕЙНОСТТА',
    details: [
      {
        text: 'Книга за регистриране заповедите на директора, примерни заповеди, AI консултант'
      },
      {
        text: 'Книга за контролната дейност на директора/заместник-директора, примерни констативни протоколи, AI консултант'
      },
      {
        text: 'Книга за решенията на педагогическия съвет'
      },
      {
        text: 'Дневници за входяща и изходяща кореспонденция'
      },
    ]
  },
  attestBookModule,
  {
    iconComponent: 'calendar-icon',
    title: 'КАЛЕНДАР НА<br>СЪБИТИЯТА',
    details: [
      {
        text: 'Въвеждане на информация за класна и контролна работа, родителска среща, консултации, тържества и други събития'
      },
      {
        text: 'Достъп на родители и ученици'
      },
      {
        text: 'Справки по вид събитие'
      },
    ]
  },
  {
    iconComponent: 'messages-icon',
    title: 'СЪОБЩЕНИЯ',
    details: [
      {
        text: 'Вътрешна училищна мрежа за обмен на съобщения между учители, ученици, родители и администрация'
      },
      {
        text: 'Създаване на потребителски групи'
      },
      {
        text: 'Препращане на съобщения'
      },
    ]
  },
  {
    iconComponent: 'mobile-icon',
    title: 'МОБИЛНО<br>ПРИЛОЖЕНИЕ',
    details: [
      {
        text: 'Въвеждане и преглед на основната информация за учебния час от учителя – тема на урок, отсъствия, оценки, забележки и др.'
      },
      {
        text: 'Информиране за различни събития в институцията'
      },
      {
        text: 'Известия за учители, ученици и родители'
      },
    ]
  },
  administrationModule
]
